const FORM_ID = 'd49f4e69-25fb-4273-a1d2-bfe43b44c1b8';
const BASE_URL = 'http://mysite.localhost';

const generateRandomTimestamp = () => {
  const start = new Date();
  const end = new Date(start.getTime() - 30 * 24 * 60 * 60 * 1000); // 30 days ago
  return new Date(start.getTime() - Math.random() * (start.getTime() - end.getTime())).getTime();
};

const generateRandomPath = () => {
  const paths = ['/home', '/products', '/contact', '/about', '/services'];
  return paths[Math.floor(Math.random() * paths.length)];
};

const generateRandomJourneyCookie = () => {
  const steps = Array.from({ length: 3 }, () => {
    const timestamp = generateRandomTimestamp();
    const path = generateRandomPath();
    return `${timestamp}:${path}`;
  });
  return steps.join('|');
};

const generateRandomSourceCookie = () => {
  const sources = ['google', 'bing', 'facebook', 'twitter', '(direct)'];
  const mediums = ['organic', 'referral', 'social', 'email', 'cpc'];
  const source = sources[Math.floor(Math.random() * sources.length)];
  const medium = mediums[Math.floor(Math.random() * mediums.length)];
  return `referrer:${source}|utm_source:${source}|utm_medium:${medium}`;
};

export default function TestFormSubmission() {
  const handleShowForm = async () => {
    try {
      const response = await fetch(`${BASE_URL}/_sf/api/v1/forms/${FORM_ID}.json`);
      const data = await response.json();
      console.log('Form submissions:', data);
      return [
        data.components.find((component) => component.label === '_sfsignature')?.defaultValue,
        data.components.find((component) => component.label === '_sftoken')?.defaultValue,
      ];
    } catch (error) {
      console.error('Error fetching form submissions:', error);
    }
  };

  const handleSubmitForm = async () => {
    const [_sfsignature, _sftoken] = await handleShowForm();

    // Generate random cookies
    const journeyCookie = generateRandomJourneyCookie();
    const sourceCookie = generateRandomSourceCookie();

    document.cookie = `_sf_journey=${encodeURIComponent(journeyCookie)}; path=/`;
    document.cookie = `_sf_source=${encodeURIComponent(sourceCookie)}; path=/`;

    try {
      const response = await fetch(`${BASE_URL}/_sf/api/v1/forms/${FORM_ID}/submission.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            firstName: 'John' + Math.random().toString(36).substring(7),
            _sfsignature,
            _sftoken,
          },
        }),
      });
      const data = await response.json();
      console.log('Form submission:', data);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div>
      <div>Test Form Submission</div>
      <pre></pre>
      <button onClick={handleSubmitForm}>Submit!</button>
    </div>
  );
}
